import { createContext, useContext } from 'react';

/**
 * Actions context for SgDatePicker
 * Contains all callback functions (stable references)
 */
export interface DatePickerActionsContextValue {
  onClose: () => void;
  onOpen: (shouldFocus: boolean) => void;
  onClear: () => void;
  onDateChange: (dateString: string) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  onInputChanged?: (value: string) => void;
  onCustomPresetClick?: (label: string) => void;
}

const DatePickerActionsContext = createContext<DatePickerActionsContextValue | undefined>(undefined);

export const DatePickerActionsProvider = DatePickerActionsContext.Provider;

export function useDatePickerActions(): DatePickerActionsContextValue {
  const context = useContext(DatePickerActionsContext);

  if (!context) {
    throw new Error('useDatePickerActions must be used within DatePickerActionsProvider');
  }

  return context;
}
